export default __webpack_public_path__ + "static/media/popup_50K.36470ec3.png";